module.exports = __webpack_public_path__ + "h5/img/mfe_19.c00ce883.jpg";